var map = {
	"./3-WIDGETLOYALTYPAGE-CONFIGURATION-BLURBS.jpg": "ab5b",
	"./about-business.jpg": "e002",
	"./about-yourself.jpg": "c44e",
	"./customization-steps.jpg": "7b33",
	"./loyalty-program-setup.jpg": "fa3b",
	"./offers-setup.jpg": "2f37",
	"./referral-program-setup.jpg": "9fee",
	"./rewards-setup.jpg": "6322",
	"./rules-setup.jpg": "f55c",
	"./widget-theme-selection.jpg": "c84e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "20ec";